// Shared helpers for "Salary from Amanat Account" (TS-1958): the form page and the
// notification detail / action modals use the same formatting and colour tokens.

export const SALARY_NOTIFICATION_CODE = "req_salary_from_amanat";

export const ENTRY_CHIP_COLORS = ["#1ab394", "#23c6c8", "#f8ac59", "#1c84c6", "#7B61C9", "#ED5565"];

export const entryChipColor = (index) => ENTRY_CHIP_COLORS[index % ENTRY_CHIP_COLORS.length];

export const formatRs = (value) => {
  const num = Number(value) || 0;
  const formatted = Math.abs(num).toLocaleString("en-US", { maximumFractionDigits: 2 });
  return `${num < 0 ? "− " : ""}Rs ${formatted}`;
};

/** Distinct employee names (FA dimension 2) of a quick entry, in line order. */
export const employeeNames = (entry) => {
  const names = [];
  (entry?.lines || []).forEach((line) => {
    const name = (line.dimension2Name || "").trim();
    if (name && !names.includes(name)) names.push(name);
  });
  return names;
};

/** Card title for a quick entry: its employee name(s), falling back to the FA description. */
export const entryTitle = (entry) => {
  const names = employeeNames(entry);
  return names.length ? names.join(", ") : entry?.description || "";
};

export const isDeductionLine = (line) => Number(line?.amount) < 0;

export const APPROVAL_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
  HOLD: 3,
  CANCELLED: 4,
};

export const statusTheme = (statusCode, isApproved) => {
  if (isApproved || statusCode === APPROVAL_STATUS.APPROVED)
    return { bg: "#ecfdf5", fg: "#047857", border: "#a7f3d0", key: "finance_salary_status_approved" };
  if (statusCode === APPROVAL_STATUS.REJECTED || statusCode === APPROVAL_STATUS.CANCELLED)
    return { bg: "#fef2f2", fg: "#b91c1c", border: "#fecaca", key: "finance_salary_status_rejected" };
  if (statusCode === APPROVAL_STATUS.HOLD)
    return { bg: "#fffbeb", fg: "#b45309", border: "#fde68a", key: "finance_salary_status_hold" };
  return { bg: "#fff7ed", fg: "#9a3412", border: "#fed7aa", key: "finance_salary_status_pending" };
};

export const readErrorMessage = (err, fallback) =>
  err?.response?.data?.message ||
  err?.response?.data?.Message ||
  (typeof err?.response?.data === "string" ? err.response.data : null) ||
  err?.message ||
  fallback;
